exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Ofk5hb88GCA1u ._1YJp8PMCeYtq56{color:#5e6c84;font-size:12px;font-weight:500;letter-spacing:.04em;line-height:16px;margin-top:16px;text-transform:uppercase;margin-bottom:8px}._2Ofk5hb88GCA1u ._1YJp8PMCeYtq56+hr{margin-top:4px}._2Ofk5hb88GCA1u ._EGDncAPM8gbug{font-weight:400}._2Ofk5hb88GCA1u a{cursor:pointer}._37svqLBUsADw_K{margin:20px 0;border-radius:3px;padding:10px}._37svqLBUsADw_K .Jl23kCidg7iQdE{margin:0 auto}._37svqLBUsADw_K p:last-child{margin-bottom:0}._37svqLBUsADw_K._2rNf3bOCSmMeqt{background:#d6ecd2}._37svqLBUsADw_K._3p0O_9daS_EOIj{background-color:#faf3c0}._37svqLBUsADw_K._1i9x-m9HtdVVwt{background-color:#f5d3ce}._37svqLBUsADw_K ul{margin:15px 0}._37svqLBUsADw_K ul li{margin-left:10px}", ""]);

// exports
exports.locals = {
	"enterpriseDashSidebar": "_2Ofk5hb88GCA1u",
	"header": "_1YJp8PMCeYtq56",
	"pending-requests-count": "_EGDncAPM8gbug",
	"enterpriseDashLicenses": "_37svqLBUsADw_K",
	"spinner": "Jl23kCidg7iQdE",
	"loaded": "_2rNf3bOCSmMeqt",
	"seatLimitNear": "_3p0O_9daS_EOIj",
	"seatLimitReached": "_1i9x-m9HtdVVwt"
};